import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { translations } from 'gipsy-misc'
import { ReusableButton } from 'gipsy-ui'

import container from './container'
import AuthBackground from 'features/auth/components/background'

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}

class InviteRequestPage extends PureComponent {
  render() {
    const { email, submitted, onSubmit, onChange } = this.props
    return submitted ? (
      <AuthBackground title={translations.auth.onList}>
        <p style={{ maxWidth: 300 }}>{translations.auth.willEmailYou}</p>
      </AuthBackground>
    ) : (
      <AuthBackground title={translations.auth.inviteOnly} linkTo="/login" linkText={translations.auth.haveAccount}>
        <form className="invite-request" onSubmit={onSubmit}>
          <p className="invite-text">{translations.auth.leaveEmail} </p>
          <input
            required
            type="email"
            placeholder={translations.auth.yourEmail}
            value={email}
            onChange={e => onChange({ paramName: 'email', value: e.target.value })}
          />
          <ReusableButton
            className="invite-submit"
            borderRadius={8}
            disabled={!email.includes('@')}
            style={{ opacity: !email.includes('@') ? 0.6 : 1 }}>
            {translations.auth.signUpForList}
          </ReusableButton>
        </form>
      </AuthBackground>
    )
  }
}

InviteRequestPage.propTypes = propTypes

export default container(InviteRequestPage)



// WEBPACK FOOTER //
// ./src/pages/inviteRequestPage/index.js